import React, { FC } from "react";
import { Link, useNavigate } from "react-router-dom";
import { StyledMenuItem } from "./styles";

interface ItemProps {
  title: string;
  to: string;
  icon: React.ReactNode;
  selected: string;
  setSelected: (title: string) => void;
  onClose?: () => void;
}

export const MenuItem: FC<ItemProps> = ({
  title,
  to,
  icon,
  selected,
  setSelected,
  onClose,
}) => {
  const navigate = useNavigate();
  const isActive = selected === title;

  return (
    <StyledMenuItem
      active={isActive}
      onClick={() => {
        setSelected(title);
        navigate(to);
        onClose && onClose();
      }}
      icon={icon}
      className={isActive ? "ps-active" : ""}
    >
      {title}
    </StyledMenuItem>
  );
};
